import { FunctionComponent } from "react";

import { type MetaVariation } from "@ui/components/content-cards/ContentBlock";
import { useComponentConfig } from "@ui/context/component-config-context";

import * as styles from "./ContentBlockCrossCommunityPost.css";

export interface ContentBlockCrossCommunityPostBaseConfig {
  defaultPrefix?: string;
}

interface Props extends ContentBlockCrossCommunityPostBaseConfig {
  componentContext?: string;
  source: string;
  metaVariation?: MetaVariation;
  className?: string;
}

const ContentBlockCrossCommunityPost: FunctionComponent<Props> = ({
  componentContext,
  source,
  className,
}) => {
  const { defaultPrefix } = useComponentConfig(
    "contentBlockCrossCommunityPost",
    componentContext || "",
  );

  return (
    <span className={className}>
      {defaultPrefix && <span className={styles.prefix}>{defaultPrefix}</span>}
      <span className={styles.community}>{source}</span>
    </span>
  );
};

export default ContentBlockCrossCommunityPost;
